import * as React from 'react';

import { Checkbox } from './components/ui/checkbox.js';

export function DimeCheckbox({ ...props }: Readonly<React.ComponentProps<typeof Checkbox>>) {
  return <Checkbox {...props} />;
}
